export default {
  namespaced: true,
  state: {
    websiteConfig: {},
    menuList: [],
    localeLang: 'zh'
  },
  mutations: {
    updateWebsiteConfig(state, data) {
      state.websiteConfig = data
    },
    updateMenuList(state, data) {
      state.menuList = data
    },
    updateLocaleLang(state, data) {
      state.localeLang = data
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js